import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/http/base.http';


@Injectable()
export class SettingsApiService extends HttpService {

   getSettings(settingsNames: Array<string>) {
      return this.post<Array<any>>('/settings/get', settingsNames);
   }

   addSettings(data: any) {
      return this.post('/settings', data);
   }
}